<template>
  <div class="show-select-info-coin">
    <table>
      <tr>
        <th class="first">قیمت لحظه ایی</th>
        <th>بیشترین قیمت</th>
        <th>کمترین قیمت</th>
        <th>تغییرات 24h</th>
        <th class="last">حجم بازار</th>
      </tr>

      <tr v-for="(item , index) in selectCoin" :key="index">
        <td class="number first" :class="{'red': item.changes < 0 , 'green' : item.changes > 0}">
          {{ item.price.toLocaleString() }}
        </td>
        <td class="number green">
          {{ item.topPrice.toLocaleString() }}
        </td>
        <td class="number red">
          {{ item.lowPrice.toLocaleString() }}
        </td>
        <td class="number" :class="{'red': item.changes < 0 , 'green' : item.changes > 0}">
          {{ item.changes.toLocaleString() }}
        </td>
        <td class="number last">
          {{ item.value.toLocaleString() }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "show-select-info-coin",
  props: ['data'],
  data() {
    return {
      selectCoin: [],
      coins: [
        {coin: 'BTC', price: 1255451, topPrice: 1451251, lowPrice: -1105565, changes: 0.6, value: 1234556},
        {coin: 'DOGE', price: 1455451, topPrice: 1545251, lowPrice: 17897565, changes: -0.8, value: 1274756},
        {coin: 'BNB', price: 17488451, topPrice: 145445251, lowPrice: -11056465, changes: 0.9, value: 15244556},
        {coin: 'ETH', price: 12452451, topPrice: 14788251, lowPrice: 74505565, changes: -0.3, value: 15457556},
        {coin: 'BCH', price: 1454451, topPrice: 5451251, lowPrice: -1454565, changes: 0.2, value: 12785756},
        {coin: 'XLM', price: 14555451, topPrice: 1455251, lowPrice: 5455565, changes: -0.1, value: 5454556},
        {coin: 'XRP', price: 4545451, topPrice: 5451251, lowPrice: -17485565, changes: 0.4, value: 14545556},
        {coin: 'TRON', price: 1545451, topPrice: 1545451, lowPrice: 1577565, changes: -0.5, value: 85774556},
      ]
    }
  },

  methods: {
    getmarket() {
      for (let i = 0; i < this.coins.length; i++) {
        if (this.data === this.coins[i].coin) {
          this.selectCoin.push(this.coins[i]);
        }
      }
    }
  },

  created() {
    this.getmarket()
  }
}
</script>

<style lang="scss" scoped>
.show-select-info-coin {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 20px;

  table {
    table-layout: fixed;
    width: 100%;

    .last{
      text-align: left !important;
    }

    .first{
      text-align: right !important;
    }

    th {
      color: rgba(215, 200, 200, 1);
      font-size: clamp(8px , 2vw , 12px);
      text-align: center;
    }

    td{
      font-size: clamp(10px , 2vw , 15px);
      text-align: center;
      font-weight: 700;
    }
  }
}

@media (max-width: 600px) {
  .show-select-info-coin {
    margin-top: 30px;
  }
}
</style>